import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from '../../../../core/contexts/useServices';
import { accountQueryKey } from './useAccount';
import { ACCOUNTS_QUERY_KEY } from './useAccounts';

export function useUpdateAccount(accountId: string | undefined) {
  const { accountService } = useServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string; timezone: string }) =>
      accountService.updateAccount(accountId!, data),
    onSuccess: () => {
      if (accountId) {
        queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
      }
      queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}
